fragment CouponFragment on Coupon {
    name
    code
    planCodes
    appliedAt
    expiresAt
    discountType
    discountAmount
    discountPercent
    displayInfo
}
